import pathify from 'vuex-pathify'

// set options
pathify.options.mapping = 'simple'

// re-export
export default pathify
